import * as Sentry from '@sentry/browser';

// https://70d60fe4c5464913b68abadadc6a15df@sentry.io/2873241

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://b2240d53a4ee48ac85b46584628a581b@sentry.io/631608',
    environment: process.env.BUILD_ENVIRONMENT || 'development',
  });
};

export const captureMessage = (message, info) => {
  Sentry.configureScope(scope => {
    scope.setLevel('warning');
    scope.setExtra('info', info);
  });
  Sentry.captureMessage(message, info);
};

export const captureException = (error, info) => {
  Sentry.configureScope(scope => {
    scope.setLevel('error');
    scope.setExtra('info', info);
  });
  Sentry.captureException(error, info);
};

export const setSentryUser = user => {
  Sentry.configureScope(scope => {
    scope.setUser(user);
  });
};

export const clearSentryUser = () => {
  Sentry.configureScope(scope => scope.clear());
};
